import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { tripsDataFeatureKey } from './feature-key';
import { tripsDataReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { tripDataEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(tripsDataFeatureKey, tripsDataReducer),
    EffectsModule.forFeature(tripDataEffects),
  ],
})
export class TripsDataModule {}
